"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = _interopRequireDefault(require("../../styles/icons"));

var _colors = _interopRequireDefault(require("./colors"));

var _theme = require("../../styles/theme");

var iconVariants = _interopRequireWildcard(require("./styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDefaultColor = function getDefaultColor(props) {
  if (props.color) {
    return props.color;
  }

  if (_colors.default[props.type]) {
    return _colors.default[props.type].normal;
  }

  return '';
};

var Icon = ( /*#__PURE__*/0, _styledBase.default)('i', {
  target: "eeqdolf0",
  label: "Icon"
})("font-style:inherit;color:", function (props) {
  return getDefaultColor(props);
}, ";display:inline-flex;align-items:center;justify-content:center;text-align:center;&::before{", _theme.fonts.icons, ";content:\"", function (props) {
  return _icons.default[props.type];
}, "\";line-height:inherit;color:inherit;}&:hover{color:", function (props) {
  return _colors.default[props.type] ? _colors.default[props.type].hover : '';
}, ";}", function (props) {
  return props.withText ? iconVariants.withText : '';
}, ";", function (props) {
  return props.withTextLeft ? iconVariants.withTextLeft : '';
}, ";", function (props) {
  return props.fixedWidth ? iconVariants.fixedWidth : '';
}, ";", function (props) {
  return props.flip ? iconVariants.flip : '';
}, ";", function (props) {
  return props.spin ? iconVariants.spin : '';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
exports.Icon = Icon;
Icon.defaultProps = {
  withText: false,
  withTextLeft: false,
  fixedWidth: true,
  spin: '',
  flip: '',
  color: null,
  children: null
};
Icon.propTypes = {
  withText: _propTypes.default.bool,
  withTextLeft: _propTypes.default.bool,
  spin: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool,
  flip: _propTypes.default.string,
  type: _propTypes.default.string.isRequired,
  color: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string])
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/ui_elements/icons/index.js
// module id = 24
// module chunks = 0 15 16 17 18